<template>
  <a v-if="componentType === AppLinkView.a" class="app-link app-link--a" v-bind="componentAttrs">
    <slot />
  </a>

  <router-link v-else class="app-link app-link--router-link" v-bind="componentAttrs" @click.native="onClickLink">
    <slot />
  </router-link>
</template>

<script>
const AppLinkView = {
  a: 'a',
  routerLink: 'router-link',
}

export default {
  name: 'AppLink',
  props: {
    to: {
      type: String,
      required: true,
    },
    openExternalInCurrentTab: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    AppLinkView() {
      return AppLinkView
    },
    parsedUrl() {
      try {
        if (this.isHashOnlyUrl(this.to)) {
          return new URL(`${this.$route.path}${this.to}`, window.location.origin)
        }

        if (this.isAbsoluteUrl(this.to)) {
          return new URL(this.to)
        }

        if (this.vueRoute) {
          return new URL(this.vueRoute.path, window.location.origin)
        }

        return new URL(this.to, window.location.origin)
      } catch (error) {
        console.error(`[AppLink] ${error}`)
        return null
      }
    },
    vueRoute() {
      if (!this.$router) {
        return null
      }

      const matched = this.$router.matcher.match({ name: this.to }).matched
      return matched[matched.length - 1]
    },
    isExternalLink() {
      if (!this.parsedUrl) {
        return false
      }

      return this.parsedUrl.hostname !== window.location.hostname
    },
    isCurrentPath() {
      if (this.isExternalLink || !this.parsedUrl || !this.$route) {
        return false
      }

      return this.$route.path === this.parsedUrl.pathname
    },
    urlHash() {
      if (!this.parsedUrl?.hash) {
        return ''
      }

      return this.parsedUrl.hash
    },
    componentType() {
      if (this.isExternalLink) {
        return AppLinkView.a
      }

      return AppLinkView.routerLink
    },
    componentAttrs() {
      if (this.componentType === AppLinkView.a) {
        return {
          ...this.$attrs,
          href: this.parsedUrl.href,
          target: this.openExternalInCurrentTab ? '_self' : '_blank',
          rel: this.openExternalInCurrentTab ? null : 'noopener noreferrer',
        }
      }

      if (!this.$router) {
        console.warn(`[AppLink] Vue Router instance is not available. Link ${this.to}`)
        return { ...this.$attrs, to: this.to }
      }

      return {
        ...this.$attrs,
        to: {
          path: this.parsedUrl.pathname,
          query: this.getUrlQuery(this.parsedUrl.searchParams),
          hash: this.parsedUrl.hash,
        },
      }
    },
  },
  methods: {
    isAbsoluteUrl(url) {
      return /^https?:\/\//i.test(url)
    },
    isHashOnlyUrl(url) {
      return url.trim().startsWith('#')
    },
    scrollToBlock(elem) {
      const animationOffset = elem.getAttribute('data-animate') === 'false' ? 50 : 0
      const headerHeight = document.querySelector('header')?.clientHeight ?? 0
      const top = elem.getBoundingClientRect().top + window.pageYOffset - headerHeight - animationOffset

      window.scrollTo({
        top: top,
        behavior: 'smooth',
      })
    },
    onClickLink(event) {
      // event click.native сalled only for vue-router
      if (!this.isCurrentPath || !this.urlHash) {
        return
      }

      const el = document.querySelector(this.urlHash)

      if (!el) {
        console.warn(`[AppLink] Anchor target "${this.urlHash}" was not found in DOM.`)
        return
      }

      event.preventDefault()
      this.scrollToBlock(el)
    },
    getUrlQuery(searchParams = []) {
      const query = {}

      searchParams.forEach((value, key) => {
        query[key] = value
      })

      return query
    },
  },
}
</script>

<style lang="sass">
.app-link
  display: inline-block
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/AppLink.vue